/** Branch context for data migration — matches employee list scoping. */
import { getOverviewBranchFilter } from "../../utils/branchSession";

export const getMigrationBranchId = () => {
    try {
        const overviewFilter = getOverviewBranchFilter();
        if (overviewFilter) return String(overviewFilter);

        const active = sessionStorage.getItem("active_branch_id");
        if (active && active !== "all" && active !== "null") return active;

        const home = sessionStorage.getItem("branch_id");
        if (home && home !== "null" && home !== "") return home;
    } catch {
        /* ignore */
    }
    return null;
};

export const migrationBranchFilter = () => {
    const id = getMigrationBranchId();
    return id ? { branch: id } : {};
};

export const migrationBranchLabel = () => {
    try {
        const activeName = sessionStorage.getItem("active_branch_name");
        if (activeName && activeName !== "All Branches") return activeName;
        return sessionStorage.getItem("branch_name") || "";
    } catch {
        return "";
    }
};

export const migrationBranchRequired = () => !getMigrationBranchId();
